import * as zod from "zod";
import { RateCalculatorSessionConfigSchema } from "./rate-calculator-session-config";

export const getRateCalculatorSession = {
  name: "getRateCalculatorSession" as const,
  input: zod.object({ sessionId: zod.string() }),
  output: zod.object({ configState: RateCalculatorSessionConfigSchema }),
};
